@switch (section()) {
  @case ('title') {
    <div class="skeleton skeleton-header-title"></div>
  }
  @case ('actions') {
    <div class="quotation-map-header-right">
      <div class="quotation-map-actions-main">
        <div class="quotation-map-total-block">
          <span class="quotation-map-total-label">Total negociado das seleções:</span>
          <div class="skeleton skeleton-total-header-value"></div>
          <div class="skeleton skeleton-saving-chip"></div>
        </div>

        <div class="skeleton skeleton-btn-activity"></div>
        <div class="skeleton skeleton-btn-approve"></div>
      </div>
    </div>
  }
  @case ('bestPriceToggle') {
    <div class="best-price-toggle best-price-toggle-skeleton">
      <div class="skeleton skeleton-checkbox"></div>
      <div class="skeleton skeleton-best-price-text"></div>
    </div>
  }
}
